import { useQuery } from '@tanstack/react-query'
import axiosAPI from '../axiosAPI';

export const useLawsuitClientPositions = ( ) => {

    const query = useQuery(['LawsuitClientPositions'], () => 
        axiosAPI.get('/lawsuit_client_positions')
        .then((res) => res.data)
    );

    return {
        lawsuitClientPositions: query.data?.lawsuit_client_positions,
        isLoading: query.isLoading, 
        isError: query.error, 
        isFetching: query.isFetching
    };
}